export default __webpack_public_path__ + "static/media/2249.aaf6b388.png";